
import { JsonPatchOperation } from "common/services/api/attorney-hub-api-service";
import _ from "lodash";
import VendorRepresentativeAPIRequest from "work/entities/entity-vendor-representative/api/request-contracts/vendor-representative-api-request";
import EntityVendorRepresentative from "work/entities/entity-vendor-representative/entity-vendor-representative";
import TeamTemplate from "work/entities/team-template/team-template";
import EntityMemberAPIRequest from "work/values/entity-member/api/request-contracts/entity-member-api-request";
import VendorTeamName from "work/values/vendor-team-name/vendor-team-name";
import VendorTeam from "work/values/vendor-team/vendor-team";


export default class UpdateWorkTeamTemplateAPIRequest {
  payload: JsonPatchOperation[] = [];

  constructor(originalTemplate: TeamTemplate, updatedTeam: VendorTeam, updatedTeamName: VendorTeamName) {
    if (originalTemplate.name !== updatedTeamName) {
      this.payload.push({
        op: "replace",
        path: "/name",
        value: updatedTeamName.value
      });
    }
    if (originalTemplate.leader.userId?.isEqualTo(updatedTeam.leader?.userId) && updatedTeam.leader?.entityId) {
      const vendorRep = new EntityVendorRepresentative(updatedTeam.leader.userId, updatedTeam.leader.entityId)
      this.payload.push({
        op: "replace",
        path: "/leader",
        value: new VendorRepresentativeAPIRequest(vendorRep)
      });
    }
    if (!_.isEqual(originalTemplate.memberUserIds, updatedTeam.members.map(member => member.userId))) {
      this.payload.push({
        op: "replace",
        path: "/members",
        value: updatedTeam.members.map(member => new EntityMemberAPIRequest(member.userId, member.entityId).payload)
      });
    }
    if (originalTemplate.marketplaceId?.isEqualTo(updatedTeam.marketplaceId)) {
      this.payload.push({
        op: "replace",
        path: "/marketplaceId",
        value: updatedTeam.marketplaceId?.value
      });
    }
  }
}
